module.exports = __webpack_public_path__ + "static/media/001-instagram-2-black.750b8bd3.svg";